import { render } from "./FieldInformation.vue?vue&type=template&id=83f9e628&scoped=true"
import script from "./FieldInformation.vue?vue&type=script&lang=js"
export * from "./FieldInformation.vue?vue&type=script&lang=js"

import "./FieldInformation.vue?vue&type=style&index=0&id=83f9e628&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83f9e628"]])

export default __exports__